import React from 'react';
import { Route, IndexRoute, Redirect } from 'react-router';

// shared
import RouterLayout from '../components/RouterLayout';
import RolesIndexPage from '../components/RolesIndexPage';
import UnauthorizedPage from '../components/share/UnauthorizedPage';
// album pages
import {AdminIndexPage,SchoolSearchPage,UserSearchPage,StudentSearchPage,SetPublicAccountPage,PdfTaskPage,UploadReviewPage}  from '../components/album/AdminIndexPage';
import PostsIndexPage from '../components/album/PostsIndexPage';
import StudentPostsIndexPage from '../components/album/StudentPostsIndexPage';
import ClassAlbumsIndexPage from '../components/album/ClassAlbumsIndexPage';
import ClassAlbumEditPage from '../components/album/ClassAlbumEditPage';
import ClassRecordIndexPage from '../components/album/ClassRecordIndexPage';
import ClassManagePage from '../components/album/ClassManagePage';
// achive pages
import ArchiveReviewSchoolPage from '../components/archive/ArchiveReviewSchoolPage';
import ArchiveReviewClassPage from '../components/archive/ArchiveReviewClassPage';

import ArchiveBookClassesListPage from '../components/archive/ArchiveBookClassesListPage';
import ArchiveBookStudentsListPage from '../components/archive/ArchiveBookStudentsListPage';
import ArchiveBookStudentDetailPage from '../components/archive/ArchiveBookStudentDetailPage';

import ArchiveContentSettingIndexPage from '../components/archive/ArchiveContentSettingIndexPage';
import ArchiveContentSettingClassPage from '../components/archive/ArchiveContentSettingClassPage';
import ArchiveChooseTemplatePage from '../components/archive/ArchiveChooseTemplatePage';

import ArchiveContentEditPage from '../components/archive/ArchiveContentEditPage';
import ArchiveStoryEditPage from '../components/archive/ArchiveStoryEditPage';
import ArchiveRecordIndexPage from '../components/archive/ArchiveRecordIndexPage';
// class info pages
import NotificationsPage from '../components/classinfo/NotificationsPage';
import NotificationsOfClassPage from '../components/classinfo/NotificationsOfClassPage';
// school admin pages
import SchoolAdminClassManagePage from '../components/schooladmin/SchoolAdminClassManagePage';
import ImportStudentsPage from '../components/schooladmin/ImportStudentsPage';
import ImportAllStudentsPage from '../components/schooladmin/ImportAllStudentsPage';
import ImportAllTeachersPage from '../components/schooladmin/ImportAllTeachersPage';
import SchoolClassesManageIndexPage from '../components/schooladmin/SchoolClassesManageIndexPage';
import SchoolAdminFrame from '../components/schooladmin/SchoolAdminFrame';
import TeacherManagementPage from '../components/schooladmin/TeacherManagementPage';
import SetAdminPage from '../components/schooladmin/SetAdminPage';
import UsageReportPage from '../components/schooladmin/UsageReportPage';
import ClassUsageReportPage from '../components/schooladmin/ClassUsageReportPage';
import RegisterationReportPage from '../components/schooladmin/RegisterationReportPage';
// attendance
import StudentAttendanceRercordIndexPage from '../components/attendance/StudentAttendanceRercordIndexPage';
import StudentAttendanceRercordClassDetailPage from '../components/attendance/StudentAttendanceRercordClassDetailPage';
import StudentAttendanceStatisticsIndexPage from '../components/attendance/StudentAttendanceStatisticsIndexPage';
import StudentAttendanceStatisticsClassDetailPage from '../components/attendance/StudentAttendanceStatisticsClassDetailPage';
import StudentAttendanceRecognitionIndexPage from '../components/attendance/StudentAttendanceRecognitionIndexPage';
import StudentAttendanceRecognitionClassDetailPage from '../components/attendance/StudentAttendanceRecognitionClassDetailPage';
import StudentAttendanceCalendarIndexPage from '../components/attendance/StudentAttendanceCalendarIndexPage';
import AttendanceSetCalendarPage from '../components/attendance/AttendanceSetCalendarPage';

import TeacherAttendanceRercordIndexPage from '../components/attendance/TeacherAttendanceRercordIndexPage';
import TeacherAttendanceRecognitionPage from '../components/attendance/TeacherAttendanceRecognitionPage';
import TeacherAttendanceStatisticsIndexPage from '../components/attendance/TeacherAttendanceStatisticsIndexPage';
import AttendanceDetailPage from '../components/attendance/AttendanceDetailPage';

// 打卡
import ClockComponent from '../components/clock/ClockComponent';
import ClockIndexPage from '../components/clock/ClockIndexPage';
import ClockDetailPage from '../components/clock/ClockDetailPage';
import ClockContent from '../components/clock/ClockContent';
import CreateTaskPage from '../components/clock/CreateTaskPage';

// 发展评价
import ObservationRecordFrame from '../components/development/ObservationRecordFrame';
import ObservationAdminPage from '../components/development/ObservationAdminPage';
import ObservationIndexPage from '../components/development/ObservationIndexPage';
import ObservationStudentsListPage from '../components/development/ObservationStudentsListPage';
import ObservationRecordPage from '../components/development/ObservationRecordPage';

import EvaluateIndexPage from '../components/development/EvaluateIndexPage';
import StudentObservationsListPage from '../components/development/StudentObservationsListPage';
import ClassEvaluationIndexPage from '../components/development/ClassEvaluationIndexPage';

import DevelopmentReportIndexPage from '../components/development/DevelopmentReportIndexPage';
import DevelopmentReportDetailPage from '../components/development/DevelopmentReportDetailPage';

// 档案完成进度
import ArchiveProcessIndexPage from '../components/process/ArchiveProcessIndexPage';
import ArchiveProcessClassDetailPage from '../components/process/ArchiveProcessClassDetailPage';
import ArchiveProcessStudentsDetailPage from '../components/process/ArchiveProcessStudentsDetailPage';
import ArchiveProcessSettingPage from '../components/process/ArchiveProcessSettingPage';

export default (
  <Route path="/" component={RouterLayout}>
    <IndexRoute component={RolesIndexPage} />

    <Route path="error/unauthorized" component={UnauthorizedPage} />

    <Route path="albums/admin" component={AdminIndexPage}/>
    <Route path="system-admin/school-search" component={SchoolSearchPage}/>
    <Route path="system-admin/user-search" component={UserSearchPage}/>
    <Route path="system-admin/student-search" component={StudentSearchPage}/>
    <Route path="system-admin/set-public-account/:type" component={SetPublicAccountPage}/>
    <Route path="system-admin/pdf-task/:task" component={PdfTaskPage}/>
    <Route path="system-admin/upload-review" component={UploadReviewPage}/>

    <Route path="albums/index" component={ClassAlbumsIndexPage} />
    <Route path="albums/:albumId/edit" component={ClassAlbumEditPage} />
    <Route path="albums/create" component={ClassAlbumEditPage} />
    <Route path="albums/:albumId/posts" component={PostsIndexPage} />
    <Route path="albums/manage" component={ClassManagePage} />

    <Route path="record/index" component={ClassRecordIndexPage} />
    <Route path="record/students/:studentId" component={StudentPostsIndexPage} />
    <Route path="record/manage" component={ClassManagePage} />

    <Route path="archive/book" component={ArchiveBookClassesListPage} />
    <Route path="archive/book/classes/:classId" component={ArchiveBookStudentsListPage} />
    <Route path="archive/book/classes/:classId/students/:studentId" component={ArchiveBookStudentDetailPage} />

    <Route path="school-admin/schools/:schoolId/class-management" component={SchoolClassesManageIndexPage}/>
    <Route path="school-admin/schools/:schoolId/class-management/classes/:classId" component={SchoolAdminClassManagePage} />
    <Route path="school-admin/schools/:schoolId/class-management/classes/:classId/import-students" component={ImportStudentsPage} />

    <Route path="school-admin/schools/:schoolId" component={SchoolAdminFrame}>
      <Route path="teacher-management" component={TeacherManagementPage} />
      <Route path="teacher-management/set-admin" component={SetAdminPage} />
    </Route>
    <Route path="school-admin/schools/:schoolId/usage-report" component={UsageReportPage}/>
    <Route path="school-admin/schools/:schoolId/usage-report/classes/:classId" component={ClassUsageReportPage}/>
    <Route path="school-admin/schools/:schoolId/registeration-report" component={RegisterationReportPage}/>
    <Route path="school-admin/schools/:schoolId/import-students" component={ImportAllStudentsPage}/>
    <Route path="school-admin/schools/:schoolId/import-teachers" component={ImportAllTeachersPage}/>


    <Route path="archive/review/schools/:schoolId" component={ArchiveReviewSchoolPage} />
    <Route path="archive/review/classes/:classId" component={ArchiveReviewClassPage} />

    <Route path="archive/content-setting/schools/:schoolId" component={ArchiveContentSettingIndexPage} />
    {/* <Route path="archive/content-setting/schools/:schoolId/classes/:classId" component={ArchiveContentSettingClassPage} /> */}
    <Route path="archive/content-setting/schools/:schoolId/classes/:classId" component={ArchiveRecordIndexPage} />
    <Route path="archive/content-setting/schools/:schoolId/classes/:classId/choose-template" component={ArchiveChooseTemplatePage} />

    {/* 档案进度 */}
    <Route path="archive/archive-process/schools/:schoolId" component={ArchiveProcessIndexPage} />
    <Route path="archive/archive-process/schools/:schoolId/classes/:classId" component={ArchiveProcessClassDetailPage} />
    <Route path="archive/archive-process/schools/:schoolId/classes/:classId/process-detail" component={ArchiveProcessStudentsDetailPage} />
    <Route path="archive/archive-process/schools/:schoolId/process-setting" component={ArchiveProcessSettingPage} />


    <Route path="archive/record/index" component={ArchiveRecordIndexPage} />
    <Route path="archive/record/edit" component={ArchiveContentEditPage} />
    <Route path="archive/record/story" component={ArchiveStoryEditPage} />

    <Route path="notifications" component={NotificationsPage} />
    <Route path="notifications/classes/:classId" component={NotificationsOfClassPage} />

    {/* 考勤 */}
    <Route path="student-attendance/schools/:schoolId/attendance-record" component={StudentAttendanceRercordIndexPage} />
    <Route path="student-attendance/schools/:schoolId/attendance-record/classes/:classId" component={StudentAttendanceRercordClassDetailPage} />
    <Route path="student-attendance/schools/:schoolId/attendance-calendar" component={StudentAttendanceCalendarIndexPage} />
    <Route path="student-attendance/schools/:schoolId/attendance-recognition" component={StudentAttendanceRecognitionIndexPage} />
    <Route path="student-attendance/schools/:schoolId/attendance-recognition/classes/:classId" component={StudentAttendanceRecognitionClassDetailPage} />
    <Route path="student-attendance/schools/:schoolId/attendance-statistics" component={StudentAttendanceStatisticsIndexPage} />
    <Route path="student-attendance/schools/:schoolId/attendance-statistics/classes/:classId" component={StudentAttendanceStatisticsClassDetailPage} />

    <Route path="teacher-attendance/schools/:schoolId/attendance-record" component={TeacherAttendanceRercordIndexPage} />
    <Route path="teacher-attendance/schools/:schoolId/attendance-statistics" component={TeacherAttendanceStatisticsIndexPage} />
    <Route path="teacher-attendance/schools/:schoolId/attendance-recognition" component={TeacherAttendanceRecognitionPage} />

    <Route path="student-attendance/schools/:schoolId/attendance-calendar/grades/:gradeId" component={AttendanceSetCalendarPage} />
    <Route path="teacher-attendance/schools/:schoolId/attendance-calendar" component={AttendanceSetCalendarPage} />

    <Route path="student-attendance/schools/:schoolId/attendance-statistics/classes/:classId/students/:studentId" component={AttendanceDetailPage} />
    <Route path="teacher-attendance/schools/:schoolId/attendance-statistics/teachers/:teacherId" component={AttendanceDetailPage} />
    <Route path="teacher-attendance/attendance-detail" component={AttendanceDetailPage} />

    {/* 打卡 */}
    <Route path="clock-in" component={ClockComponent} />
    <Route path="clock-in/clock-index" component={ClockIndexPage} />
    <Route path="clock-in/tasks/:taskId" component={ClockDetailPage} />
    <Route path="clock-in/tasks/:taskId/clock-content" component={ClockContent} />
    <Route path="clock-in/create-task" component={CreateTaskPage} />

    <Route path="development" component={ObservationRecordFrame}>
      <Redirect to="observation-record" />
      <Route path="observation-record" component={ObservationAdminPage}></Route>
      <Route path="observation-record/classes/:classId" component={ObservationIndexPage}></Route>
      <Route path="observation-record/classes/:classId/observations/:observationId" component={ObservationStudentsListPage}></Route>
      <Route path="observation-record/classes/:classId/observations/:observationId/students/:studentId" component={ObservationRecordPage}></Route>

      <Route path="evaluation-record" component={ObservationAdminPage}></Route>
      <Route path="evaluation-record/classes/:classId" component={EvaluateIndexPage}></Route>
      <Route path="evaluation-record/classes/:classId/students/:studentId" component={StudentObservationsListPage}></Route>
      <Route path="evaluation-record/classes/:classId/students/:studentId/observations/:observationId" component={ObservationRecordPage}></Route>

      <Route path="class-evaluation" component={ObservationAdminPage}></Route>
      <Route path="class-evaluation/classes/:classId" component={ClassEvaluationIndexPage}></Route>
      <Route path="class-evaluation/classes/:classId/observations/:observationId/students/:studentId" component={ObservationRecordPage}></Route>

      <Route path="report" component={ObservationAdminPage}></Route>
      <Route path="report/classes/:classId" component={DevelopmentReportIndexPage}></Route>
      <Route path="report/classes/:classId/get_report" component={DevelopmentReportDetailPage}></Route>
    </Route>
  </Route>
);

{/*
    <Route path="student-attendance/attendance-statistics" component={StudentAttendanceStatisticsPage} />
<Route path="student-attendance/attendance-image" component={StudentAttendanceImagePage} /> */}
  // <Route path="student-attendance/attendance-calendar" component={StudentAttendanceCalendarPage} />


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/routes/routes.jsx